import { FiftyFiftyProps } from 'lib/components/FiftyFifty/FiftyFifty'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'

export interface AboutPageContent {
  hero: NarrativeHeroProps
  fifties: FiftyFiftyProps[]
}

interface FiftyFiftyTextFields {
  header: string
  subHeader: string
  image: string
  body: React.ReactNode
  button?: {
    text: string
    link?: {
      href: string
    }
    action?: 'booking-widget-redirect'
  }
}

const commonFiftyFiftyProps = {
  backgroundColor: 'grey' as 'white' | 'grey',
  showEyebrow: false,
}

const BACKGROUND_IMAGE = '/images/shipsticks/hero-background-4.jpg'

const hero: NarrativeHeroProps = {
  backgroundImage: BACKGROUND_IMAGE,
  header: 'Created by golfers for golfers.',
  subHeader:
    'Hate checking bags? Us, too. That’s why we created ShipSticks, ' +
    'which ships your clubs right to your destination so you can breeze right by baggage claim.',
}

const fiftyTexts: FiftyFiftyTextFields[] = [
  {
    header: 'Our story',
    subHeader: 'It all started with a golf trip.',
    image: '/images/shipsticks/about-image-1.jpg',
    button: {
      text: 'Get started',
      action: 'booking-widget-redirect',
    },
    body: (
      <>
        <p>
          Two friends wanted to play golf together but one had to fly to the course. He didn&apos;t
          want to drag his clubs through the airport, wait in baggage lines, or worry about damage.
          So he shipped his clubs. The travel experience? Great. The price? Not so much. Looking to
          offer hassle-free travel at a more affordable cost, the two friends launched ShipSticks in
          2011. Their main goal then and now:
          <b> Helping golfers skip baggage claim forever.</b>
        </p>
      </>
    ),
  },
  {
    header: 'How it works',
    subHeader: 'Shipping is easy.',
    image: '/images/shipsticks/about-image-2.jpg',
    button: {
      text: 'Get the details',
      link: {
        href: '/how-it-works',
      },
    },
    body: (
      <>
        <p>
          Place your order, pack up your clubs as you would for flying, and attach your provided
          shipping label. ShipSticks can pick up your bag at your home, office, or golf course, or
          you can drop it off at a local carrier. Your gear will be waiting for you at your
          destination.
        </p>
      </>
    ),
  },
  {
    header: 'What Sets Us Apart',
    subHeader: 'Great value and personalized service.',
    image: '/images/shipsticks/about-image-3.jpg',
    button: {
      text: 'See more benefits',
      link: {
        href: '/guarantee',
      },
    },
    body: (
      <>
        <p>
          With ShipSticks, you not only save time at the airport, you also enjoy savings passed on
          from our shipping discounts. We guarantee on-time delivery and provide complimentary
          insurance, live tracking, and customer support seven days a week.
        </p>
      </>
    ),
  },
  {
    header: 'Beyond Golf Bags',
    subHeader: 'We ship. You play.',
    image: '/images/shipsticks/about-image-4.jpg',
    button: {
      text: 'Visit Ship&Play',
      link: {
        href: 'https://shipplay.com',
      },
    },
    body: (
      <>
        <p>
          ShipSticks success proved people crave alternatives to traveling with unwieldy sports gear
          and bulky luggage. With that in mind, We launched{' '}
          <a href={'https://shipskis.com'} className="underline">
            ShipSkis
          </a>
          ,{' '}
          <a href={'https://shipcamps.com'} className="underline">
            ShipCamps
          </a>
          , and acquired{' '}
          <a href={'https://luggagefree.com'} className="underline">
            Luggage Free
          </a>
          . Along with ShipSticks, these are all part of{' '}
          <a href={'https://shipplay.com'} className="underline">
            Ship&Play
          </a>
          , a seamless, door-to-door shipping solution for travelers worldwide.
        </p>
      </>
    ),
  },
]

const fifties: FiftyFiftyProps[] = fiftyTexts.map((text, index) => ({
  ...text,
  image: {
    src: text.image,
    alt: text.header,
  },
  layout: index % 2 === 0 ? 'image-right' : 'image-left',
  ...commonFiftyFiftyProps,
}))

const content: AboutPageContent = {
  hero,
  fifties,
}

export default content
